import { Box, List, ListItem, Stack, Typography } from '@mui/material';
import { FOOTER_HEIGHT } from '../../constants/layout';
import { StrapiPiedPageEntity } from '../../models/layout';
import { localizeUrl } from '../../utils/tools';
import { Link } from '../atoms/Link';
import { Container } from './Container';
import { Image } from '../atoms/Image';
import { useViewport } from '../../hooks/useViewport';

export type FooterProps = {
  piedPage?: StrapiPiedPageEntity;
};

export const Footer = ({ piedPage }: FooterProps) => {
  const { isSmallViewport } = useViewport();
  if (!piedPage) return null;

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: FOOTER_HEIGHT,
        backgroundColor: 'primary.main'
      }}
    >
      <Container>
        {!isSmallViewport && (
          <Link
            to={localizeUrl('/')}
            sx={{
              display: 'inline-block',
              maxWidth: '8rem',
              lineHeight: 0,
              position: 'absolute'
            }}
          >
            <Image
              src="/images/logo-melusine-light.png"
              alt={'logo'}
              sx={{ height: 'auto', width: '100%' }}
            />
          </Link>
        )}
        <Stack direction="column" justifyContent="center" alignItems="center" width="100%">
          <List sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignContent: 'center',
            flexWrap: 'wrap',
            width: '75%'
          }}>
            {(piedPage.LiensReseauxSociaux ?? []).map(({Label, Lien}) => (
              <ListItem key={Label} sx={{ justifyContent: 'center', width: 'unset' }}>
                <Link
                  href={Lien}
                  sx={{
                    fontSize: { xs: '1.5rem!Important', md: '1.75rem!Important' },
                    color: 'primary.light',
                    textAlign: 'center',
                    mx: '2rem',
                    my: '1rem'
                  }}
                >
                  {Label}
                </Link>
              </ListItem>
            ))}
          </List>
          <List sx ={{
            display: 'flex',
            justifyContent: 'space-around',
            alignContent: 'center',
            flexWrap: 'wrap',
            width: '75%',
            mb: '2rem'
          }}>
            {(piedPage.AutresLiens ?? []).map(({Label, Lien}) => (
              <ListItem key={Label} sx={{ justifyContent: 'center', width: 'unset' }} >
                <Link to={Lien} sx={{ color: 'primary.light', textAlign: 'center', mx: '2rem', my: '0.5rem' }}>
                  <Typography variant="body2">{Label}</Typography>
                </Link>
              </ListItem>
            ))}
          </List>
        </Stack>
      </Container>
    </Box>
  );
};
